// Placeholder - cần chuyển đổi từ app/training_groups/group/[id]/page.tsx
export default function TrainingGroupGroupPage() {
  return <div>TrainingGroupGroupPage - Đang được chuyển đổi</div>
}

